import React, { useRef } from 'react';
import { useFadeInAnimation } from '../../hooks/useGsapAnimation';

const WhyJoinAgastya = () => {
  // Create refs for animation targets
  const sectionRef = useRef(null);
  const headingRef = useRef(null);
  const paragraphRef = useRef(null);
  
  // Use our custom animation hook
  useFadeInAnimation({
    sectionRef,
    elements: [headingRef, paragraphRef],
    config: {
      start: "top 80%",
      stagger: 0.3,
      duration: 0.9,
      y: 50,
      ease: "power3.out"
    }
  });

  return (
    <section ref={sectionRef} className="px-4 md:px-20 lg:pl-[80px] lg:pr-[84px] py-[60px] md:py-[80px] overflow-hidden">
      <div className="max-w-[1275px] mx-auto">
        <div className="flex flex-col gap-4 md:gap-16 pr-[15px] md:pr-0">
          <h2 
            ref={headingRef} 
            className="font-[LTWave] font-medium text-3xl md:text-4xl lg:text-[44px] leading-[150%] will-change-transform"
          >
            Why You Should Join Agastya Agro
          </h2>
          
          <p 
            ref={paragraphRef} 
            className="font-inter font-normal text-base md:text-lg leading-[150%] opacity-40 will-change-transform"
          >
            At Agastya, we foster a collaborative and inclusive environment where every team member's contribution is valued. <br />
            We believe in continuous learning and growth, providing opportunities for professional development and advancement. 
            With a team of 250+ professionals, we bring together expertise in production, R&D, field extension, and farmer 
            engagement—working toward the shared goal of empowering Indian agriculture.
          </p>
        </div>
      </div>
    </section>
  );
};

export default WhyJoinAgastya;
